import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock3 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import ClockingMachineModeArticle from '../../components/ClockingMachineModeArticle';

export default function ClockingMachineMode() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-800">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
        <div className="bg-gradient-to-r from-primary/20 to-cyan-500/10 border border-primary/20 rounded-2xl p-6 lg:p-8">
          <div className="flex items-center gap-3 mb-3">
            <Clock3 size={26} className="text-cyan-400" />
            <span className="inline-flex items-center rounded-full border border-cyan-400/30 bg-cyan-500/10 px-3 py-1 text-xs font-semibold tracking-wide text-cyan-300">
              {t('guide.clockingMachineModeBadge', 'Clocking Machine Mode')}
            </span>
          </div>
          <h1 className="text-3xl lg:text-4xl font-bold text-white mb-3">
            {t('guide.clockingMachineModePageTitle', 'How to Turn Old Devices into Staff Clock-In Terminals')}
          </h1>
          <p className="text-gray-300 max-w-3xl leading-relaxed">
            {t(
              'guide.clockingMachineModePageIntro',
              'Reuse old tablets and spare phones as shared staff clock-in terminals with BuildMyShifts. Reduce hardware costs, improve attendance tracking, and give managers instant visibility from one simple setup.'
            )}
          </p>
          <div className="flex flex-wrap gap-3 mt-5">
            <Link
              to="/register"
              className="inline-flex items-center gap-2 rounded-lg bg-primary px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-dark transition-colors"
            >
              {t('publicNav.startTrial', 'Start Free Trial')}
              <ArrowRight size={16} />
            </Link>
            <Link
              to="/guide"
              className="inline-flex items-center gap-2 rounded-lg border border-white/15 bg-white/5 px-5 py-2.5 text-sm font-semibold text-gray-200 hover:bg-white/10 transition-colors"
            >
              {t('nav.guide', 'Guide')}
            </Link>
          </div>
        </div>

        <ClockingMachineModeArticle headingAs="h2" />
      </main>
    </div>
  );
}
